import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialTrialInstitutionItemCustomViewState: Dtos.TrialInstitutionItemCustomView & IRegistrationFormState = {
    id: null,

    trialId: null,
    personnelId: null,
    name: null,
    description: null,
    sortOrder: null,
    isShared: null,
    trialItemSelections: null,
    compactTextArea: null,
    trialInstitutionItemCustomViewItems: [],
    customDataEntryColumns: [],
    trialItemDataEntryByInstitutions: [],
    trialItemDataEntryByItemComponentPrimitives: [],
    itemComponentRules: [],
    trialInstitutions: [],
    itemComponentWithDatas: [],

    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
}

export interface ITrialInstitutionItemCustomViewReduxFormState {
    id: IFieldState<number>,

    trialId: IFieldState<number>,
    personnelId: IFieldState<number>,
    name: IFieldState<string>,
    description: IFieldState<string>,
    sortOrder: IFieldState<number>,
    isShared: IFieldState<boolean>,
    trialItemSelections: IFieldState<Dtos.TrialItemSelection[]>,
    compactTextArea: IFieldState<boolean>,

    itemComponentWithDatas: IFieldState<Dtos.ItemComponentWithData[]>,

    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    message: IFieldState<string>,
    openedModals: IFieldState<string[]>
}
